import { EbookDiscount } from './EbookDiscount'
import { withEbookDiscount } from './withEbookDiscount'

const Connected = withEbookDiscount(EbookDiscount)

export { Connected as EbookDiscount }
